import { useTheme } from '@/contexts/ThemeContext';
/** Duration + session-type pill used by every cardio picker (custom builder + weekly view). */
export const CardioDurationPill = ({ duration, sessionType, testId }) => {
  const { accentTheme } = useTheme();
  // recovery / rounds keep the original artwork because their hue-rotate tints are session-type
  // colours, not the theme accent.
  const tinted = sessionType === 'recovery' || sessionType === 'rounds';
  return (
  <div className="relative w-full mt-2" style={{ aspectRatio: '5.55' }} data-testid={testId}>
    <img
      src={tinted
        ? (sessionType === 'steady' ? '/pill-cardio.png' : '/pill-cardio-interval.png')
        : `/pills/${sessionType === 'steady' ? 'pill-cardio' : 'pill-cardio-interval'}-${accentTheme}.webp`}
      alt=""
      className="absolute inset-0 w-full h-full"
      // The orange artwork is tinted to the recovery red / rounds yellow used on the session-type cards.
      style={sessionType === 'recovery'
        ? { filter: 'hue-rotate(-31deg) saturate(0.72) brightness(1.12)' }
        : sessionType === 'rounds'
          ? { filter: 'hue-rotate(24deg) saturate(1.1) brightness(1.25)' }
          : undefined}
      draggable={false}
    />
    <span
      className="absolute inset-y-0 flex items-center justify-center font-heading font-black text-white text-[11px]"
      style={{ left: '22.4%', width: '28.9%', textShadow: '0 1px 2px rgba(0,0,0,0.8)' }}
    >
      {duration}M
    </span>
    <span
      className="absolute inset-y-0 flex items-center justify-center font-heading font-black text-white text-[9px] uppercase"
      style={{ left: '58.7%', width: '36.9%', textShadow: '0 1px 2px rgba(0,0,0,0.8)' }}
    >
      {sessionType}
    </span>
  </div>
);
};
